var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-page" },
    [
      _c("page-header", { attrs: { minWidth: 1280, userName: _vm.userName } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-top" },
        [
          _c("UnionActivity"),
          _vm._v(" "),
          _c("div", { staticClass: "buy-title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "tip" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_DONT_KNOW")))
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.jianguoyun.com/s/helpdesk",
                  target: "_blank"
                }
              },
              [_vm._v(_vm._s(_vm.getConstants("PRICING_NEW_DONT_KNOW_ASK")))]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("Buy"),
      _vm._v(" "),
      _c("Profit"),
      _vm._v(" "),
      _c("Faq"),
      _vm._v(" "),
      _c("NutstoreRobot"),
      _vm._v(" "),
      _c("page-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }